export const SET_ADMIN_SESSION = 'SET_ADMIN_SESSION';

export const actionSetAdminSession = admin => ({
    type: SET_ADMIN_SESSION,
    payload: admin
})
